import React, { useEffect, useRef } from "react";
import { loadCategoryDropdownRequest } from "../../escalation_rule_builder/redux/Actions";
import { loadCategoryGetDataRequest } from "../redux/Actions";
import { useDispatch, useSelector } from "react-redux";

const CategoryInheritFrom = ({ setFieldValue, setSubCategories, companyId }) => {
  const dispatch = useDispatch();
  const inheritTriggered = useRef(false);

  const { categoryList } = useSelector((state) => state.ticketingDropdowns);
  const { category, categories } = useSelector((store) => store.categories);

  // Reload category dropdown whenever companyId changes
  // If no company selected → fetch all, otherwise filter by company
  useEffect(() => {
    if (companyId) {
      dispatch(loadCategoryDropdownRequest({ companyId }));
    } else {
      dispatch(loadCategoryDropdownRequest());
    }
  }, [companyId, dispatch]);

  const handleChange = (e) => {
    const categoryId = e.target.value;
    if (!categoryId) return;
    inheritTriggered.current = true;
    dispatch(loadCategoryGetDataRequest(categoryId));
  };

  useEffect(() => {
    if (!inheritTriggered.current) return;
    if (!category || Object.keys(category).length === 0) return;

    inheritTriggered.current = false;
    const data = category;
    const activeQuestions = (data.questions || []).filter(  (q) => q.is_active);


    const categoryId = data.categories?.category?.id;
    const matchedCat = categories?.data?.find((cat) => cat.id === categoryId);

    const builtSubCategories = matchedCat?.sub_category?.map((sub) => ({
      id: sub.s_id, label: sub.s_name, value: sub.s_name, __isNew__: false,
    })) || [];

    const subCatsFromResponse = data.categories?.category?.sub_category?.map((sub) => ({
      id: sub.s_id, label: sub.s_name, value: sub.s_name, __isNew__: false,
    })) || [];

    const finalSubCategories = builtSubCategories.length > 0 ? builtSubCategories : subCatsFromResponse;

    setSubCategories(finalSubCategories);
    setFieldValue("categories.category", data.categories?.category
      ? { id: data.categories.category.id, label: data.categories.category.label, value: data.categories.category.value, __isNew__: false }
      : null
    );

    const inheritedSubCat = data.categories?.subCategory;
    const matchedSub = finalSubCategories.find(
      (s) => s.id === inheritedSubCat?.id || s.value === inheritedSubCat?.value
    );
    setFieldValue("categories.subCategory", matchedSub
      ? { id: matchedSub.id, label: matchedSub.label, value: matchedSub.value, __isNew__: false }
      : null
    );

    setFieldValue("description", data.description || "");
    setFieldValue("ticketType", data.ticketType || "");
    setFieldValue("isTicketNotAllowed", data.isTicketNotAllowed ?? false);
    setFieldValue("ticketingportal", data.ticketingportal ?? false);
    setFieldValue("adminportal", data.adminportal ?? false);
    setFieldValue("ticketingportalgroup", data.ticketingportalgroup || []);
    setFieldValue("adminportalgroup", data.adminportalgroup || []);
    setFieldValue("questions", activeQuestions);
    setFieldValue("routing", {
      adminGroup: data.routing?.adminGroup ? Number(data.routing.adminGroup) : null,
      assignedTo: data.routing?.assignedTo ? Number(data.routing.assignedTo) : null,
    });
    setFieldValue("templateId", data.templateId || null);
    setFieldValue("questionMode", data.questionMode || "custom");
    setFieldValue("childDepartments", data.childDepartments || []);

  }, [category, categories, setFieldValue, setSubCategories]);

  return (
    <div>
      <label className="form-label">Category to Copy</label>
      <select className="form-select" onChange={handleChange} defaultValue="">
        <option value="" disabled>
          {companyId ? "Select Category to Inherit" : "Select a company first"}
        </option>
        {categoryList?.map((item) => (
          <option key={item.value} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoryInheritFrom;